import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Upload, Download, PlayCircle } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { OptionSelect } from "@/components/data/FieldInput";
import { ResourceTable } from "@/components/data/ResourceTable";
import { PageHeader } from "@/components/data/StatusBadge";
import { ImportDialog, downloadModele } from "@/components/tfj/ImportDialog";
import { RecapTable } from "@/components/tfj/RecapTable";
import { useAuth } from "@/context/AuthContext";
import { api, fmtDate } from "@/lib/api";

function Recap() {
  const [journees, setJournees] = useState([]);
  const [jid, setJid] = useState(null);
  useEffect(() => {
    api.get("/r/journees", { params: { size: 400 } }).then((r) => {
      setJournees(r.data.items);
      if (r.data.items[0]) setJid(r.data.items[0].id);
    }).catch(() => {});
  }, []);
  if (!journees.length) return <div className="p-10 text-center text-sm text-muted-foreground border rounded-lg bg-card">Aucune journée importée</div>;
  return (
    <div className="space-y-4">
      <div className="w-full sm:w-72"><OptionSelect options={journees.map((j) => ({ value: j.id, label: `${fmtDate(j.date)} — ${j.statut === "cloturee" ? "clôturée" : "ouverte"}` }))} value={jid} onChange={(v) => v && setJid(v)} testId="recap-journee-select" /></div>
      {jid && <RecapTable journeeId={jid} initial="zone" />}
    </div>
  );
}

export default function TfjPage() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [imp, setImp] = useState(false);
  const extraActions = (row) => [{ key: "traiter", label: "Traiter la journée", icon: PlayCircle, onClick: (r) => nav(`/tfj/journees/${r.id}`) }];
  return (
    <div>
      <PageHeader title="TFJ — Traitement financier journalier" subtitle="Import des résultats par TPE (Loto, Hippique, Sport), contrôle, encaissements des superviseurs, répartition et clôture verrouillée de la journée.">
        <Button variant="outline" size="sm" onClick={downloadModele} data-testid="tfj-download-template"><Download className="h-4 w-4 mr-1" />Modèle Excel</Button>
        {can("tfj", "creer") && <Button size="sm" onClick={() => setImp(true)} data-testid="tfj-import-button"><Upload className="h-4 w-4 mr-1" />Importer une journée</Button>}
      </PageHeader>
      <Tabs defaultValue="journees">
        <TabsList className="mb-4 flex-wrap h-auto">
          <TabsTrigger value="journees" data-testid="tab-journees">Journées</TabsTrigger>
          <TabsTrigger value="recap" data-testid="tab-recap">Récapitulatif journalier</TabsTrigger>
          <TabsTrigger value="lignes" data-testid="tab-lignes">Lignes par TPE</TabsTrigger>
          <TabsTrigger value="encaissements" data-testid="tab-encaissements">Encaissements</TabsTrigger>
        </TabsList>
        <TabsContent value="journees"><ResourceTable res="journees" extraActions={extraActions} /></TabsContent>
        <TabsContent value="recap"><Recap /></TabsContent>
        <TabsContent value="lignes"><ResourceTable res="tfj_lignes" /></TabsContent>
        <TabsContent value="encaissements"><ResourceTable res="encaissements" /></TabsContent>
      </Tabs>
      <ImportDialog open={imp} onOpenChange={setImp} onDone={(jid) => nav(`/tfj/journees/${jid}`)} />
    </div>
  );
}
